import StatusBar from './StatusBar';
import Breadcrumb from './Breadcrumb';
import BottomNavBar from './BottomNavBar';
import Footer from './Footer';  // Cookie Settings footer
import UserStatusBanner from './UserStatusBanner';  // User status + Ko-fi button
import ReportProblemButton from './ReportProblemButton';  // Feedback system

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {

    return (
        <div className="flex flex-col h-dvh overflow-hidden relative bg-black min-h-dvh">
            {/* Top Bar with Status and Breadcrumb - All Screens */}
            <div className="sticky top-0 z-20 w-full bg-primary-bg/95 backdrop-blur-md border-b border-border-color" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
                <StatusBar />
                <Breadcrumb />
            </div>

            <main className="flex-1 w-full box-border bg-content-bg flex-grow pb-24 overflow-y-auto pt-1 px-4 sm:pt-2 sm:px-6 md:pt-2 md:px-8 lg:pt-2 lg:px-10 xl:pt-2 xl:px-12 2xl:pt-2 2xl:px-16 3xl:pt-2 3xl:px-20">
                <div className="max-w-full mx-auto lg:max-w-content xl:max-w-content-wide 3xl:max-w-content-ultra">
                    {/* UserStatusBanner and Report Button - Horizontally Aligned - All Pages */}
                    <div className="flex items-start justify-between mb-2 -mt-2 -ml-3 sm:-mt-2 sm:-ml-5 md:-mt-2 md:-ml-7 lg:-mt-2 lg:-ml-9 xl:-mt-2 xl:-ml-11 2xl:-mt-2 2xl:-ml-15 3xl:-mt-2 3xl:-ml-19">
                        <UserStatusBanner />
                        <div className="ml-2">
                            <ReportProblemButton />
                        </div>
                    </div>

                    {children}
                </div>
            </main>

            {/* Footer with Cookie Settings */}
            <Footer />

            {/* Bottom Navigation - All Screens */}
            <BottomNavBar />
        </div>
    );
};

export default Layout;

